import { AmpEvent } from "@redotech/redo-model/email-builder/amp-utils";

export function serializedAmpEvent<EventType extends AmpEvent>(
  event: EventType,
  actions?: string,
): string {
  if (!actions) return "";
  return `${event}:${actions}`;
}
